<template>
  <div>
    <Nav />
    <div class="pwcontent">
      <el-form :model="ruleForm2" ref="ruleForm" class="shadow form-wrap">
        <div class="pass-wrap">
          <el-form-item label="旧密码" prop="rgEmpty">
            <el-input
              v-model="ruleForm2.oldpassword"
              name="oldpassword"
              type="password"
              placeholder="请输入旧密码"
              maxlength="18"
              @keyup.native.space.passive="clearSpace('oldpassword')"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="rgPassword">
            <el-input
              type="password"
              name="password"
              @keyup.native.space.passive="clearSpace('password')"
              v-model="ruleForm2.password"
              placeholder="请输入新密码"
              maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item label="再次输入密码" prop="rgRePassword">
            <el-input
              type="password"
              name="repasswrod"
              @keyup.native.space.passive="clearSpace('repasswrod')"
              v-model="ruleForm2.repasswrod"
              placeholder="请再次输入新密码"
              maxlength="18"
            ></el-input>
          </el-form-item>
        </div>
        <el-button type="primary" size="medium" @click="submit()">提交</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from '../api'
import regExp from '../utils/regExp.js'
import Nav from '../components/Nav'
export default {
  name: 'ChangePassword',
  components: {
    Nav
  },
  data() {
    return {
      ExhID: sessionStorage.getItem('ExhID'),
      PsnID: sessionStorage.getItem('PsnID'),
      ruleForm2: {
        userName: '',
        password: '',
        repasswrod: '',
        code: '',
        iphone: '',
        oldpassword: ''
      }
    }
  },
  mounted() {},
  methods: {
    clearSpace: function(n) {
      var obj = this.ruleForm2

      obj[n] = obj[n].trim()
      this.ruleForm2 = obj
      return false
    },
    submit: function() {
      var obj = this.ruleForm2

      if (!regExp.notEmpty.test(obj.oldpassword)) {
        this.$alert('请输入旧密码')
        document.getElementsByName('oldpassword')[0].focus()
        return ''
      } else if (obj.oldpassword.length < 6) {
        this.$alert('旧密码长度不能小于6位')
        document.getElementsByName('oldpassword')[0].focus()
        return ''
      } else if (!regExp.password.test(obj.oldpassword)) {
        this.$alert('旧密码格式错误,请重新输入')
        document.getElementsByName('oldpassword')[0].focus()
        return ''
      } else if (!regExp.notEmpty.test(obj.password)) {
        this.$alert('请输入新密码')
        document.getElementsByName('password')[0].focus()
        return ''
      } else if (obj.password.length < 6) {
        this.$alert('新密码长度必能小于6位')
        document.getElementsByName('password')[0].focus()
        return ''
      } else if (!regExp.password.test(obj.password)) {
        this.$alert('新密码格式错误,请重新输入')
        document.getElementsByName('password')[0].focus()
        return ''
      } else if (!regExp.notEmpty.test(obj.repasswrod)) {
        this.$alert('请再次输入新密码')
        document.getElementsByName('repasswrod')[0].focus()
        return ''
      } else if (obj.password !== obj.repasswrod) {
        this.$alert('两次输入的密码不一致,请重新输入')
        document.getElementsByName('repasswrod')[0].focus()
        return ''
      }
      this.resetPassword()
    },
    resetPassword: function() {
      var param = {
        exhid: this.ExhID,
        PsnID: this.PsnID,
        OldPwd: this.ruleForm2.oldpassword,
        NewPwd: this.ruleForm2.password,
        Language: 'cn'
      }
      api.resetPasswrod(param).then(res => {
        if (res.data.status === 'OK') {
          this.$alert('密码修改成功')
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.pwcontent {
  width: 50%;
  min-width: 350px;
  margin: 0 auto;
}
.form-wrap {
  background: #fff;
  padding: 15px;
  text-align: center;
}
.form-wrap .code-btn {
  height: 40px;
  margin-top: 40px;
}
.shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue